import { analyticsContext } from './analytics-context';
import { type CanvasAnalyticsWebClient } from './analytics-web-client';

export type UIAnalyticsEvent = Parameters<CanvasAnalyticsWebClient['sendUIEvent']>[0];

export const fireUIEvent = async (event: UIAnalyticsEvent) => {
  if (!analyticsContext.client) {
    return;
  }

  try {
    await analyticsContext.client.sendUIEvent(event);
  } catch (e) {
    console.error(e);
  }
};

// TODO - Refactor this, now that analytics client is initialised synchronously
// at the start of our app we can likely move away from these hooks and use
// `analyticsContext.client` directly
export const useFireUIEvent = (): {
  fireUIEvent: (event: UIAnalyticsEvent) => Promise<void>;
} => {
  return { fireUIEvent };
};
